import { DeliverySlot, DeliverySlotsResponse } from '~/api/ETA';

interface NearestAvailableSlot {
  slot: DeliverySlot;
  timestamp: string;
}

const findNearestAvailableSlot = (
  slotsData: DeliverySlotsResponse,
): NearestAvailableSlot | null => {
  if (!slotsData || typeof slotsData !== 'object') {
    return null;
  }

  const sortedTimestamps = Object.keys(slotsData)
    .map((timestamp) => parseInt(timestamp, 10))
    .filter((timestamp) => !isNaN(timestamp))
    .sort((a, b) => a - b);

  for (const timestamp of sortedTimestamps) {
    const timestampKey = timestamp.toString();
    const slots = slotsData[timestampKey];

    if (Array.isArray(slots) && slots.length > 0) {
      const availableSlots = slots.filter(
        (slot) => slot.is_active && slot.remaining_capacity > 0,
      );

      if (availableSlots.length > 0) {
        return {
          slot: availableSlots[0]!,
          timestamp: timestampKey,
        };
      }
    }
  }

  return null;
};

export default findNearestAvailableSlot;
